module.exports = __webpack_public_path__ + "static/media/revision-icon.11c61e75.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/revision-icon.svg
// module id = 1069
// module chunks = 0